const StockStatus = {
    Available: 'IN_STOCK',
    OutOfStock: 'OUT_OF_STOCK',
    Unavailable: 'UNAVAILABLE',
} as const;

export const WarehouseStockStatus = {
    ...StockStatus,
    NotifyMe: 'NOTIFY_ME',
} as const;

export type WarehouseStockStatus = (typeof WarehouseStockStatus)[keyof typeof WarehouseStockStatus];

export const AllStoresStockStatus = {
    ...StockStatus,
    Online: 'ONLINE',
} as const;

export type AllStoresStockStatus = (typeof AllStoresStockStatus)[keyof typeof AllStoresStockStatus];

export const StoreStockStatus = {
    ...StockStatus,
    StockLow: 'STOCK_LOW',
    Online: 'ONLINE',
    UnavailableAllStores: 'UNAVAILABLE_ALL_STORES',
    AvailableDTS: 'AVAILABLE_DTS',
    UnavailableDTS: 'UNAVAILABLE_DTS',
} as const;

export type StoreStockStatus = (typeof StoreStockStatus)[keyof typeof StoreStockStatus];
